RivalIQ.apps.Alerts.module('views', function (views) {
    'use strict';

    function colorClass(value) {
        if (value < 0) {
            return 'tlw-text-red-400';
        } else {
            return 'tlw-text-green-400';
        }
    }

    function shortFormattedDate(date) {
        const timezone = RivalIQ.state.landscape.get('timezone');
        const formatted = RivalIQ.utils.timezone.getDateInTimezone(timezone, date).format('MMM D');
        return formatted;
    }

    views.ListeningAlert = views.Alert.extend({
        template: '#alertsListeningAlertTemplate',

        ui: {
            infoBubbles: '.fa-info-circle'
        },

        onRenderLoaded: function () {
            const me = this;
            me.ui.infoBubbles.popover();
        },

        augmentTemplateData: function (data) {
            const me = this;

            data.summaryMetrics = me.getSummaryMetrics(data);
            data.alertDescription = me.getAlertDescription();
            data.tableData = me.getTableData() || null;
        },

        getSummaryMetrics: function (data) {
            const me = this;

            const metricResults = data.data;

            const eventDateFormatted = shortFormattedDate(data.event_time);

            const eventDayDate = shortFormattedDate(me.model.get('event_time'));
            const previousDayDate = shortFormattedDate(_.last(metricResults.activityByDay.data)[0]);

            return [{
                header: 'Post Volume, Change',
                value: RivalIQ.formatter.formats.deltaRelative(metricResults.postVolumePctChange.data[0]),
                className: colorClass(metricResults.postVolumePctChange.data[0]),
                info: `The percentage increase in post volume from ${previousDayDate} to ${eventDayDate}.`
            }, {
                header: 'Daily Post Avg., last two weeks',
                value: RivalIQ.formatter.formatAbbreviated(_.last(metricResults.previousPeriodAverage.data)),
                className: '',
                info: 'The average daily posting volume that occurred in the 14 days prior to this alert.'
            }, {
                header: `Post Volume, ${eventDateFormatted}`,
                value: RivalIQ.formatter.formatAbbreviated(metricResults.postVolume.data),
                className: '',
                info: 'The number of posts on the day of the alert.'
            }];
        },

        getAlertDescription: function () {
            const me = this;

            const metricResults = me.model.get('data');

            const increasePct = metricResults.postVolumePctChange.data[0];
            const firstSentence = `Posting about ${me.model.get('name')} increased by <span class="${colorClass(increasePct)}">${RivalIQ.formatter.formats.deltaRelative(increasePct)}</span> from the last two weeks.`;

            const contextSentences = [
                firstSentence
            ];

            const significantSourceIncrease = metricResults.significantSourceIncrease;
            if (significantSourceIncrease) {
                const sourceName = significantSourceIncrease.data[0][0];
                const percentIncrease = RivalIQ.formatter.formats.percentAbsolute(metricResults.significantSourceIncreasePct.data[0][1]);
                const percentVolume = RivalIQ.formatter.formats.percentAbsolute(metricResults.significantSourceIncrease.data[0][1]);
                contextSentences.push(`
                    A single source, ${sourceName}, accounted for ${percentVolume} of the post volume and increased ${percentIncrease}.
                `);

                const alertList = $.tagHtml('ul', {
                    class: 'list-unstyled',
                    html: _.map(contextSentences, function (sentence) {
                        return $.tagHtml('li', {
                            html: sentence
                        });
                    }).join(' ')
                });

                return alertList;
            } else {
                return contextSentences.join(' ');
            }
        },

        _getTableRowsForMetric: function (dimensionName) {
            const me = this;

            const metricResults = me.model.get('data');

            const mainPeriodData = metricResults[`significant${_.upperFirst(dimensionName)}sMainPeriodCounts`];
            const deltaAbsolute = metricResults[`significant${_.upperFirst(dimensionName)}sDeltaAbsolute`];
            const comparePeriodData = metricResults[`significant${_.upperFirst(dimensionName)}sComparePeriodCounts`];

            return _.map(mainPeriodData?.data, (mainPeriodDatum) => {
                const dimensionValue = mainPeriodDatum[0];
                const deltaAbsoluteValue = _.find(deltaAbsolute.data, (deltaAbsoluteDatum) => {
                    return deltaAbsoluteDatum[0] === dimensionValue;
                })[1];
                const comparePeriodValue = _.find(comparePeriodData.data, (comparePeriodDatum) => {
                    return comparePeriodDatum[0] === dimensionValue;
                })[1];

                return {
                    dimensionValue: (dimensionName === 'phrase' ? _.upperFirst(dimensionValue) : `#${dimensionValue}`),
                    deltaAbsoluteValue: RivalIQ.formatter.formatAbbreviatedWithSign(deltaAbsoluteValue),
                    mainValue: mainPeriodDatum[1] || 0,
                    compareValue: comparePeriodValue || 0
                };
            });
        },

        getTableData: function () {
            const me = this;

            // We don't output this table if we're showing a significant source increase.
            const metricResults = me.model.get('data');
            const significantSourceIncrease = metricResults.significantSourceIncrease;
            if (significantSourceIncrease) {
                return;
            }

            const rows = me._getTableRowsForMetric('hashtag').concat(me._getTableRowsForMetric('phrase'));
            if (_.isEmpty(rows)) {
                return;
            }

            const eventDateFormatted = shortFormattedDate(me.model.get('event_time'));

            const headers = [
                {
                    header: 'Notable Terms',
                    class: ''
                },
                {
                    header: 'Post Volume, change',
                    className: 'right-align',
                    icon: 'fa-sort-down'
                },
                {
                    header: `Daily Post Avg., last two weeks`,
                    className: 'right-align'
                },
                {
                    header: `Post Volume, ${eventDateFormatted}`,
                    className: 'right-align'
                }
            ];

            return {
                headers,
                rows
            };
        }
    });

}, window.moment);
